const tipsList = [
  {
    title: '预计发送员工',
    content: '需执行群发任务的成员总数。'
  },
  {
    title: '待发送员工',
    content: '还没执行群发任务的成员总数，数据每小时更新一次。'
  },
  {
    title: '已发送员工',
    content: '已经执行群发任务的成员总数，数据每小时更新一次。'
  },
  {
    title: '发送失败员工',
    content: '由于客户接收已达上限等原因，员工无法再发送消息的成员总数。'
  },
  {
    title: '预计送达客户',
    content: '企业要求成员需发送群发内容的客户总数（去重）。'
  },
  {
    title: '待送达客户',
    content: '尚未收到群发内容的客户总数（去重），数据每小时更新一次。'
  },
  {
    title: '已送达客户',
    content: '已经收到群发内容的客户总数（去重），数据每小时更新一次。'
  },
  {
    title: '接收已达上限客户',
    content: '当月已经接受超过4次企业群发信息的客户总数（去重），数据每小时更新一次。'
  }
]

const employeesTabList = [
  { name: 'wait', label: '待发送' },
  { name: 'success', label: '已发送' }
]
const customerTabList = [
  { name: 'wait', label: '未送达' },
  { name: 'success', label: '已送达' },
  { name: 'error', label: '接收达上限客户' }
]

export { tipsList, employeesTabList, customerTabList }
